import commom from '../../translations/kr/kr_common.json';
import error from '../../translations/kr/kr_error.json';
import warning from '../../translations/kr/kr_warning.json';

export const kr = {
    ...commom,
    ...error,
    ...warning,
};